// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3-YMU","additionalInfo":"AgreementModal_additionalInfo__2vhgi"};